import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type Props = {
  onActionEditar: (IdAcaoPrevCorretiva: number | null, openState: boolean, openAnalise: boolean) => void,
  isReadOnly: boolean;
};

export const GenerateAcaoPrevAnaliseEvidenciaColumns = ({
  onActionEditar,isReadOnly
}: Props): GridColDef[] => {

  //#region FoiEficaz
  const computeItemStatusTitle = (status: boolean) => {
    switch (status) {
      case true:
        return "Sim";
      case false:
        return "Não";
      default:
        return "Análise Pendente";
    }
  }
  const computeItemStatusColor = (status: boolean) => {
    switch (status) {
      case true:
        return "green";
      case false:
        return "yellow";
      default:
        return "blue";
    }
  };

  //#endregion

  return [
    {
      field: "Numero",
      filterable: false,
      headerName: "Nº",
      maxWidth: 80,
      sortable: false,
    },
    {
      field: "FoiEficaz",
      filterable: false,
      headerName: "A ação foi eficaz?",
      flex: 1,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={""} />
        </div>
      )
    },
    {
      field: "AnaliseEvidencia",
      filterable: false,
      headerName: "Análise e evidência objetiva",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal">
          <span>{params.value }</span>
        </div>);
      },
    },
    {
      field: "NomeFuncionarioAnalise",
      filterable: false,
      headerName: "Nome do Responsável pela análise",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal">
          <span>{params.value }</span>
        </div>);
      },
    },
    {
      field: "DataAnalise",
      filterable: false,
      headerName: "Data Analise",
      flex: 1,
      maxWidth: 100,
      sortable: false,
       renderCell: (params) => {
        return (<span>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</span>);
      },
    },
    {
      field: 'IdAcaoPrevCorretiva',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        if (isReadOnly) return null;
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, false, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}